import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../config/theme';
import { useLanguage } from '../config/language';
import { Search, Car, ChevronLeft, ChevronRight, ArrowLeft, ArrowRight, Calendar, Settings } from 'lucide-react';

// Car models data by brand
const carModelsData = {
  toyota: [
    { id: 'camry', name: 'Camry', nameAr: 'كامري', years: '2018-2024', image: 'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=400' },
    { id: 'corolla', name: 'Corolla', nameAr: 'كورولا', years: '2019-2024', image: 'https://images.unsplash.com/photo-1623869675781-80aa31012a5a?w=400' },
    { id: 'land-cruiser', name: 'Land Cruiser', nameAr: 'لاند كروزر', years: '2016-2024', image: 'https://images.unsplash.com/photo-1594534475808-b18fc33b045e?w=400' },
    { id: 'prado', name: 'Prado', nameAr: 'برادو', years: '2017-2024', image: 'https://images.unsplash.com/photo-1669215420018-ca52bfd67b7c?w=400' },
    { id: 'rav4', name: 'RAV4', nameAr: 'راف فور', years: '2019-2024', image: 'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=400' },
    { id: 'hilux', name: 'Hilux', nameAr: 'هايلكس', years: '2016-2024', image: 'https://images.unsplash.com/photo-1612544448445-b8232cff3b6c?w=400' },
    { id: 'fortuner', name: 'Fortuner', nameAr: 'فورتشنر', years: '2017-2024', image: 'https://images.unsplash.com/photo-1606611013016-969c19ba27b9?w=400' },
    { id: 'yaris', name: 'Yaris', nameAr: 'ياريس', years: '2018-2024', image: 'https://images.unsplash.com/photo-1550355291-bbee04a92027?w=400' },
  ],
  nissan: [
    { id: 'patrol', name: 'Patrol', nameAr: 'باترول', years: '2016-2024', image: 'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=400' },
    { id: 'altima', name: 'Altima', nameAr: 'التيما', years: '2019-2024', image: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=400' },
    { id: 'maxima', name: 'Maxima', nameAr: 'ماكسيما', years: '2018-2024', image: 'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=400' },
    { id: 'x-trail', name: 'X-Trail', nameAr: 'إكس تريل', years: '2017-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'pathfinder', name: 'Pathfinder', nameAr: 'باثفايندر', years: '2019-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
    { id: 'sunny', name: 'Sunny', nameAr: 'صني', years: '2018-2024', image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400' },
  ],
  mercedes: [
    { id: 'c-class', name: 'C-Class', nameAr: 'الفئة C', years: '2018-2024', image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=400' },
    { id: 'e-class', name: 'E-Class', nameAr: 'الفئة E', years: '2017-2024', image: 'https://images.unsplash.com/photo-1563720360172-67b8f3dce741?w=400' },
    { id: 's-class', name: 'S-Class', nameAr: 'الفئة S', years: '2018-2024', image: 'https://images.unsplash.com/photo-1622194993589-0c8539881630?w=400' },
    { id: 'gle', name: 'GLE', nameAr: 'GLE', years: '2019-2024', image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400' },
    { id: 'gls', name: 'GLS', nameAr: 'GLS', years: '2019-2024', image: 'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=400' },
    { id: 'g-class', name: 'G-Class', nameAr: 'الفئة G', years: '2018-2024', image: 'https://images.unsplash.com/photo-1520031441872-265e4ff70366?w=400' },
  ],
  bmw: [
    { id: '3-series', name: '3 Series', nameAr: 'الفئة 3', years: '2019-2024', image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=400' },
    { id: '5-series', name: '5 Series', nameAr: 'الفئة 5', years: '2018-2024', image: 'https://images.unsplash.com/photo-1523983302122-36e3113a9670?w=400' },
    { id: '7-series', name: '7 Series', nameAr: 'الفئة 7', years: '2019-2024', image: 'https://images.unsplash.com/photo-1556189250-72ba954cfc2b?w=400' },
    { id: 'x5', name: 'X5', nameAr: 'X5', years: '2019-2024', image: 'https://images.unsplash.com/photo-1617814076367-b759c7d7e738?w=400' },
    { id: 'x7', name: 'X7', nameAr: 'X7', years: '2019-2024', image: 'https://images.unsplash.com/photo-1571127236794-81c0bbfe1ce3?w=400' },
  ],
  lexus: [
    { id: 'es', name: 'ES', nameAr: 'ES', years: '2019-2024', image: 'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=400' },
    { id: 'ls', name: 'LS', nameAr: 'LS', years: '2018-2024', image: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=400' },
    { id: 'lx', name: 'LX', nameAr: 'LX', years: '2016-2024', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400' },
    { id: 'rx', name: 'RX', nameAr: 'RX', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'gx', name: 'GX', nameAr: 'GX', years: '2019-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
  ],
  honda: [
    { id: 'accord', name: 'Accord', nameAr: 'أكورد', years: '2018-2024', image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400' },
    { id: 'civic', name: 'Civic', nameAr: 'سيفيك', years: '2019-2024', image: 'https://images.unsplash.com/photo-1597404294360-feeeda04612e?w=400' },
    { id: 'cr-v', name: 'CR-V', nameAr: 'CR-V', years: '2018-2024', image: 'https://images.unsplash.com/photo-1568844293986-8c3a88b8f109?w=400' },
    { id: 'pilot', name: 'Pilot', nameAr: 'بايلوت', years: '2019-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
  ],
  hyundai: [
    { id: 'sonata', name: 'Sonata', nameAr: 'سوناتا', years: '2019-2024', image: 'https://images.unsplash.com/photo-1629897048514-3dd7414fe72a?w=400' },
    { id: 'elantra', name: 'Elantra', nameAr: 'إلنترا', years: '2018-2024', image: 'https://images.unsplash.com/photo-1605816988069-b11383b50571?w=400' },
    { id: 'tucson', name: 'Tucson', nameAr: 'توسان', years: '2019-2024', image: 'https://images.unsplash.com/photo-1625231334168-5b14bb91b1a0?w=400' },
    { id: 'santa-fe', name: 'Santa Fe', nameAr: 'سانتا في', years: '2018-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
    { id: 'palisade', name: 'Palisade', nameAr: 'باليسيد', years: '2020-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
  ],
  kia: [
    { id: 'k5', name: 'K5', nameAr: 'K5', years: '2020-2024', image: 'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=400' },
    { id: 'sportage', name: 'Sportage', nameAr: 'سبورتاج', years: '2019-2024', image: 'https://images.unsplash.com/photo-1568844293986-8c3a88b8f109?w=400' },
    { id: 'sorento', name: 'Sorento', nameAr: 'سورينتو', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'telluride', name: 'Telluride', nameAr: 'تيلورايد', years: '2020-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
  ],
  ford: [
    { id: 'mustang', name: 'Mustang', nameAr: 'موستنج', years: '2018-2024', image: 'https://images.unsplash.com/photo-1584345604476-8ec5f82bd3a8?w=400' },
    { id: 'f-150', name: 'F-150', nameAr: 'F-150', years: '2018-2024', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400' },
    { id: 'explorer', name: 'Explorer', nameAr: 'إكسبلورر', years: '2019-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
    { id: 'expedition', name: 'Expedition', nameAr: 'إكسبيديشن', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
  ],
  chevrolet: [
    { id: 'tahoe', name: 'Tahoe', nameAr: 'تاهو', years: '2018-2024', image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400' },
    { id: 'suburban', name: 'Suburban', nameAr: 'سوبربان', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'silverado', name: 'Silverado', nameAr: 'سيلفرادو', years: '2019-2024', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400' },
    { id: 'camaro', name: 'Camaro', nameAr: 'كمارو', years: '2018-2024', image: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=400' },
  ],
  gmc: [
    { id: 'yukon', name: 'Yukon', nameAr: 'يوكن', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'sierra', name: 'Sierra', nameAr: 'سييرا', years: '2019-2024', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400' },
    { id: 'acadia', name: 'Acadia', nameAr: 'أكاديا', years: '2018-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
  ],
  'land-rover': [
    { id: 'range-rover', name: 'Range Rover', nameAr: 'رينج روفر', years: '2018-2024', image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400' },
    { id: 'range-rover-sport', name: 'Range Rover Sport', nameAr: 'رينج روفر سبورت', years: '2018-2024', image: 'https://images.unsplash.com/photo-1519245659620-e859806a8d3b?w=400' },
    { id: 'defender', name: 'Defender', nameAr: 'ديفندر', years: '2020-2024', image: 'https://images.unsplash.com/photo-1606611013016-969c19ba27b9?w=400' },
    { id: 'discovery', name: 'Discovery', nameAr: 'ديسكفري', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
  ],
  porsche: [
    { id: 'cayenne', name: 'Cayenne', nameAr: 'كايين', years: '2018-2024', image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400' },
    { id: 'panamera', name: 'Panamera', nameAr: 'باناميرا', years: '2018-2024', image: 'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=400' },
    { id: '911', name: '911', nameAr: '911', years: '2019-2024', image: 'https://images.unsplash.com/photo-1614162692292-7ac56d7f7f1e?w=400' },
    { id: 'macan', name: 'Macan', nameAr: 'ماكان', years: '2019-2024', image: 'https://images.unsplash.com/photo-1580274455191-1c62238fa333?w=400' },
  ],
  audi: [
    { id: 'a4', name: 'A4', nameAr: 'A4', years: '2018-2024', image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400' },
    { id: 'a6', name: 'A6', nameAr: 'A6', years: '2018-2024', image: 'https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=400' },
    { id: 'a8', name: 'A8', nameAr: 'A8', years: '2019-2024', image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400' },
    { id: 'q7', name: 'Q7', nameAr: 'Q7', years: '2018-2024', image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400' },
    { id: 'q8', name: 'Q8', nameAr: 'Q8', years: '2019-2024', image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400' },
  ],
};

// Brand names mapping
const brandNames = {
  toyota: { name: 'Toyota', nameAr: 'تويوتا', logo: 'https://www.carlogos.org/car-logos/toyota-logo-2019-3700x1200.png' },
  nissan: { name: 'Nissan', nameAr: 'نيسان', logo: 'https://www.carlogos.org/car-logos/nissan-logo-2020-black.png' },
  mercedes: { name: 'Mercedes-Benz', nameAr: 'مرسيدس بنز', logo: 'https://www.carlogos.org/car-logos/mercedes-benz-logo-2011-1920x1080.png' },
  bmw: { name: 'BMW', nameAr: 'بي إم دبليو', logo: 'https://www.carlogos.org/car-logos/bmw-logo-2020-gray.png' },
  lexus: { name: 'Lexus', nameAr: 'لكزس', logo: 'https://www.carlogos.org/car-logos/lexus-logo-1988-1920x1080.png' },
  honda: { name: 'Honda', nameAr: 'هوندا', logo: 'https://www.carlogos.org/car-logos/honda-logo-1700x1150.png' },
  hyundai: { name: 'Hyundai', nameAr: 'هيونداي', logo: 'https://www.carlogos.org/car-logos/hyundai-logo-2011-1920x1080.png' },
  kia: { name: 'Kia', nameAr: 'كيا', logo: 'https://www.carlogos.org/car-logos/kia-logo-2021-2560x1440.png' },
  ford: { name: 'Ford', nameAr: 'فورد', logo: 'https://www.carlogos.org/car-logos/ford-logo-2017-1500x1101.png' },
  chevrolet: { name: 'Chevrolet', nameAr: 'شيفروليه', logo: 'https://www.carlogos.org/car-logos/chevrolet-logo-2013-2560x1440.png' },
  gmc: { name: 'GMC', nameAr: 'جي إم سي', logo: 'https://www.carlogos.org/car-logos/gmc-logo-2200x700.png' },
  'land-rover': { name: 'Land Rover', nameAr: 'لاند روفر', logo: 'https://www.carlogos.org/car-logos/land-rover-logo-2011-1920x1080.png' },
  porsche: { name: 'Porsche', nameAr: 'بورش', logo: 'https://www.carlogos.org/car-logos/porsche-logo-2100x1100.png' },
  audi: { name: 'Audi', nameAr: 'أودي', logo: 'https://www.carlogos.org/car-logos/audi-logo-2016-1920x1080.png' },
};

export default function CarPartsModels() {
  const { brandId } = useParams();
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const { language } = useLanguage();
  const isAr = language === 'ar';
  
  const [searchQuery, setSearchQuery] = useState('');

  const brand = brandNames[brandId];
  const models = carModelsData[brandId] || [];

  // Filter models
  const filteredModels = models.filter(model => 
    model.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    model.nameAr.includes(searchQuery)
  );

  if (!brand) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-[#0a0a0a] text-white' : 'bg-gray-50 text-[#0f172a]'}`}>
        <div className="text-center">
          <Car className="h-16 w-16 mx-auto mb-4 text-gray-400" />
          <h2 className="text-2xl font-bold mb-2">{isAr ? 'الماركة غير موجودة' : 'Brand not found'}</h2>
          <button onClick={() => navigate('/spare-parts')} className="text-orange-500 hover:underline">
            {isAr ? 'العودة للماركات' : 'Back to brands'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#0a0a0a]' : 'bg-gray-50'}`}>
      {/* Hero Section */}
      <section className={`relative py-10 ${isDarkMode ? 'bg-gradient-to-b from-orange-500/20 to-transparent' : 'bg-gradient-to-b from-orange-500/10 to-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/spare-parts')}
            className={`flex items-center gap-2 mb-6 transition-colors ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-[#0f172a]'}`}
          >
            {isAr ? <ArrowRight className="w-5 h-5" /> : <ArrowLeft className="w-5 h-5" />}
            <span>{isAr ? 'العودة للماركات' : 'Back to brands'}</span>
          </button>

          <div className="flex items-center gap-6">
            {/* Brand Logo */}
            <div className={`w-24 h-24 sm:w-32 sm:h-32 rounded-2xl flex items-center justify-center p-4 ${isDarkMode ? 'bg-white/10' : 'bg-white shadow-lg'}`}>
              <img 
                src={brand.logo} 
                alt={brand.name}
                className="w-full h-full object-contain"
              />
            </div>

            <div>
              <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full mb-2 text-sm ${isDarkMode ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-500/10 text-orange-600'}`}>
                <Settings className="w-4 h-4" />
                <span>{isAr ? 'قطع الغيار' : 'Spare Parts'}</span>
              </div>
              <h1 className={`text-3xl sm:text-4xl font-bold ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
                {isAr ? brand.nameAr : brand.name}
              </h1>
              <p className={`mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                {isAr ? `${filteredModels.length} موديل متاح` : `${filteredModels.length} models available`}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Search */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className={`rounded-2xl p-4 ${isDarkMode ? 'bg-[#141414] border border-white/10' : 'bg-white shadow-sm'}`}>
          <div className="relative">
            <Search className={`absolute ${isAr ? 'right-4' : 'left-4'} top-1/2 -translate-y-1/2 w-5 h-5 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} />
            <input
              type="text"
              placeholder={isAr ? 'ابحث عن موديل...' : 'Search model...'}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className={`w-full ${isAr ? 'pr-12 pl-4' : 'pl-12 pr-4'} py-3 rounded-xl text-base transition-all ${isDarkMode ? 'bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:border-orange-500/50' : 'bg-gray-50 border border-gray-200 text-[#0f172a] placeholder-gray-400 focus:border-orange-500'} focus:outline-none focus:ring-2 focus:ring-orange-500/20`}
              data-testid="search-model"
            />
          </div>
        </div>
      </section>

      {/* Models Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        {filteredModels.length === 0 ? (
          <div className={`text-center py-20 rounded-2xl ${isDarkMode ? 'bg-[#141414]' : 'bg-white'}`}>
            <Car className={`h-16 w-16 mx-auto mb-4 ${isDarkMode ? 'text-gray-700' : 'text-gray-300'}`} />
            <p className={`text-xl font-medium mb-2 ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
              {isAr ? 'لا توجد موديلات' : 'No models found'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredModels.map((model) => (
              <Link
                key={model.id}
                to={`/spare-parts/${brandId}/${model.id}`}
                className={`group rounded-2xl overflow-hidden transition-all hover:scale-[1.02] ${isDarkMode ? 'bg-[#141414] border border-white/10 hover:border-orange-500/50 hover:shadow-lg hover:shadow-orange-500/10' : 'bg-white border border-gray-200 hover:border-orange-500/50 hover:shadow-xl'}`}
                data-testid={`model-${model.id}`}
              >
                {/* Car Image */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={model.image} 
                    alt={model.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=400';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  
                  {/* Model Name Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-xl font-bold text-white">
                      {isAr ? model.nameAr : model.name}
                    </h3>
                  </div>
                </div>

                {/* Details */}
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-sm">
                      <Calendar className={`w-4 h-4 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} />
                      <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>{model.years}</span>
                    </div>
                    <div className={`flex items-center gap-1 text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity`}>
                      <span className="text-sm font-medium">{isAr ? 'القطع' : 'Parts'}</span>
                      {isAr ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
